import React from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { SelectWidgetWrapper } from '../common/select-widget/SelectWidgetWrapper';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { ISingleSelectWidget, SingleSelectKind } from './ISingleSelectWidget';
import { SingleSelectRadioComponent } from './component/SingleSelectRadioComponent';
import { SingleSelectSelectComponent } from './component/SingleSelectSelectComponent';
import { useSingleSelectWidgetOptions } from './hooks/useSingleSelectWidgetOptions';

export interface ISingleSelectWidgetComponentProps
  extends IWidgetComponentProps<ISingleSelectWidget> {}

export function SingleSelectWidgetComponent(
  props: ISingleSelectWidgetComponentProps,
) {
  const { widget } = props;

  const widgetOptions = getWidgetProps(props);

  const { options, componentOptions } = useSingleSelectWidgetOptions({
    widget,
    name: widgetOptions.name,
    preview: widgetOptions.preview,
  });

  return (
    <SelectWidgetWrapper {...props}>
      {widget.kind === SingleSelectKind.Radio ? (
        <SingleSelectRadioComponent
          {...props}
          options={options}
          componentOptions={componentOptions}
        />
      ) : (
        <SingleSelectSelectComponent
          {...props}
          options={options}
          componentOptions={componentOptions}
        />
      )}
    </SelectWidgetWrapper>
  );
}
